import { render } from "./NavBlock.vue?vue&type=template&id=c9b09840&scoped=true"
import script from "./NavBlock.vue?vue&type=script&lang=js"
export * from "./NavBlock.vue?vue&type=script&lang=js"

import "./NavBlock.vue?vue&type=style&index=0&id=c9b09840&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9b09840"]])

export default __exports__